import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import ActivitySummaryTable from './activity-summary-table';
import LatestBanner from './latest-banner';
import QuickLinksSelector from './quick-links-selector';
import QuickLinkDisplay from './quick-link-display';
import BannerPreviewModal from './banner-preview-modal';
import EmptyState from '../../../shared/empty-state/components/empty-state';
import CreateCampaignModal from '../../campaigns/components/create-campaign-modal';
import ChooseCampaignModal from '../../campaigns/components/choose-campaign-modal';
import MobileCampaignModal from '../../campaigns/components/mobile-campaign-modal';
import RenderIf from '../../../shared/render-if/components/render-if';
import ButtonsSelector from '../../../shared/buttons-selector/components/buttons-selector';
import DefaultLoader from '../../../shared/default-loader/components/default-loader';
import DashboardHelpers from '../helpers/dashboard-helpers';
import dashboardConstants from '../constants/dashboard-constants';
import registerConstants from '../../register/constants/register-constants';
import { toggleChooseCampaignModal } from '../../campaigns/actions/campaigns-actions';

import '../styles/activity-summary.css';

class ActivitySummary extends Component {
  state = {
    userType: dashboardConstants.filter_user_types.trader,
  };

  openChooseCampaignModal() {
    const { toggleChooseCampaignModal } = this.props;

    toggleChooseCampaignModal(true);
  }

  onUserTypeChange(userType) {
    this.setState({ userType });
  }

  render() {
    const { userType } = this.state;
    const { summaryData, partnersSummaryData, fetchingSummaryData, profile, campaigns, showBannerPreviewModal } = this.props;

    if (profile && profile.user_type === registerConstants.user_types.ifs_type) {
      _.remove(dashboardConstants.activity_summary_table[0].columns, { column: 'commission_earned' });
    }

    const data = userType.value === dashboardConstants.filter_user_types.trader.value ? summaryData || {} : partnersSummaryData || {};
    const table = DashboardHelpers.formatSummaryData(dashboardConstants.activity_summary_table, data, profile);
    
    return (
      <div className="activity-summary-container">
        <RenderIf if={showBannerPreviewModal}>
          <BannerPreviewModal />
        </RenderIf>
        <RenderIf if={profile}>
          <ChooseCampaignModal />
        </RenderIf>
        <RenderIf if={profile}>
          <CreateCampaignModal />
        </RenderIf>
        <MobileCampaignModal />
        <RenderIf if={!fetchingSummaryData}>
          <div className="col-md-5 col-sm-12 m-t-20">
            <ButtonsSelector items={_.values(dashboardConstants.filter_user_types)} selectedValue={userType} onClick={this.onUserTypeChange.bind(this)} />
            <ActivitySummaryTable table={table} />
          </div>
        </RenderIf>
        <RenderIf if={fetchingSummaryData}>
          <div className="col-md-5 col-sm-12 p-a-30">
            <DefaultLoader />
          </div>
        </RenderIf>
        <RenderIf if={profile && campaigns && campaigns.length > 0}>
          <div className="col-md-7 col-sm-12 p-t-10 text-center">
            <QuickLinksSelector />
            <QuickLinkDisplay />
            <LatestBanner />
          </div>
        </RenderIf>
        <RenderIf if={campaigns && campaigns.length === 0}>
          <div className="col-md-7 col-sm-12 p-t-10 text-center">
            <EmptyState title={'CAMPAIGNS.NO_CAMPAIGNS_MESSAGE'} actionButtonLabel={'CAMPAIGNS.CREATE_FIRST_CAMPAIGN'} callback={this.openChooseCampaignModal.bind(this)} />
          </div>
        </RenderIf>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  summaryData: state.dashboardReducer.summaryData,
  partnersSummaryData: state.dashboardReducer.partnersSummaryData,
  fetchingSummaryData: state.dashboardReducer.fetchingSummaryData,
  showBannerPreviewModal: state.dashboardReducer.showBannerPreviewModal,
  profile: state.userProfileReducer.profile,
  campaigns: state.campaignsReducer.campaigns,
});

const mapDispatchToProps = dispatch => ({
  toggleChooseCampaignModal: show => {
    dispatch(toggleChooseCampaignModal(show));
  },
});

ActivitySummary.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivitySummary);



// WEBPACK FOOTER //
// ./src/app/main/dashboard/components/activity-summary.js